declare global {
  interface Window {
    cookieSettingsPage: string;
  }
}

const getCookieValue = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
};

export const initCookie = () => {
  const cookieButtonsParent = document.querySelector("[data-cookie-banner]") as HTMLElement | null;

  if (!cookieButtonsParent) return;

  if (getCookieValue("user_accept_cookie")) {
    cookieButtonsParent.style.display = "none";
    return;
  }

  const cookieButtons = document.querySelectorAll("button[data-cookie]") as NodeList;

  if (cookieButtons.length === 0) return;

  for (const cookieButton of cookieButtons) {
    cookieButton.addEventListener("click", (event: Event) => {
      const { cookie } = (event.currentTarget as HTMLButtonElement).dataset;

      if (cookie === "accept") {
        document.cookie = "user_accept_cookie=1; path=/; max-age=86400";
        cookieButtonsParent?.classList.add("--accepted");
      } else {
        window.location.href = window.cookieSettingsPage;
      }
    });
  }
};
